import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-omirlsite',
  templateUrl: './omirlsite.component.html',
  styleUrls: ['./omirlsite.component.less']
})
export class OmirlsiteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
